import { Slot } from "expo-router";

import { MainLayout } from "~/component/layout";

const Layout = () => {
  return (
    <MainLayout>
      <Slot />
    </MainLayout>
  );
};

export default Layout;
